import React from 'react';
import Cropper from 'react-easy-crop';
import '../Common/imageCropper.css';

const ImageCropper = ({
	crop,
	zoom,
	onCropChange,
	onCropComplete,
	currentPhoto,
	onZoomChange,
}) => {
	return (
		<>
			<div className='image-block'>
				<Cropper
					minZoom={1}
					image={currentPhoto}
					crop={crop}
					zoom={zoom}
					restrictPosition={true}
					zoomWithScroll={false}
					objectFit='contain'
					onCropChange={onCropChange}
					onCropComplete={onCropComplete}
					onZoomChange={onZoomChange}
				/>
			</div>
		</>
	);
};

export default ImageCropper;
